"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JsonFormSchema = exports.SectionSchema = exports.SchedulerFieldSchema = exports.LabelFieldSchema = exports.TextFieldSchema = void 0;
const zod_1 = require("zod");
exports.TextFieldSchema = zod_1.z.object({
    type: zod_1.z.literal("text"),
    label: zod_1.z.string(),
    fieldName: zod_1.z.string(),
    valueType: zod_1.z.enum(["number", "text", "password"]),
    gridWidth: zod_1.z.number(),
    fieldWidth: zod_1.z.number(),
    required: zod_1.z.boolean().optional(),
    helperText: zod_1.z.string().optional(),
    regex: zod_1.z.string().optional(),
    regexError: zod_1.z.string().optional(),
});
exports.LabelFieldSchema = zod_1.z.object({
    type: zod_1.z.literal("label"),
    primary: zod_1.z.string(),
    secondary: zod_1.z.string(),
    gridWidth: zod_1.z.number(),
    fieldWidth: zod_1.z.number(),
});
exports.SchedulerFieldSchema = zod_1.z.object({
    type: zod_1.z.literal("schedule"),
    label: zod_1.z.string(),
    fieldName: zod_1.z.literal("schedule"),
    gridWidth: zod_1.z.number(),
    fieldWidth: zod_1.z.number(),
    required: zod_1.z.boolean().optional(),
    helperText: zod_1.z.string().optional(),
});
exports.SectionSchema = zod_1.z.object({
    title: zod_1.z.string(),
    description: zod_1.z.string(),
    imageUrl: zod_1.z.string().optional(),
    fields: zod_1.z.array(zod_1.z.union([exports.TextFieldSchema, exports.LabelFieldSchema, exports.SchedulerFieldSchema]))
});
exports.JsonFormSchema = zod_1.z.object({
    url: zod_1.z.string(),
    sections: zod_1.z.array(exports.SectionSchema)
});
